export default __webpack_public_path__ + "6999c629d4b903700e07819e4b6f2fa4.png";